export default "__VITE_ASSET__Dp4RTFPn__"